export abstract class Plugin {
    public abstract init(element: Element): void;

    protected notify(element: Element | JQuery) {
        document.dispatchEvent(new CustomEvent("dom-updated", {
            detail: {
                element: element,
                plugin: this,
            }
        }));
    }

    public register() {
        document.addEventListener("dom-updated", (event: CustomEvent) => {
            if (event.detail.plugin !== this) {
                this.init(event.detail.element);
            }
        });

        document.dispatchEvent(new CustomEvent("plugin-registered", {
            detail: {
                init: this.init.bind(this),
            }
        }));
    }
}

export function registerPlugin(pluginClass: new () => Plugin) {
    const plugin = new pluginClass();
    plugin.register();
}

export function notifyPluginsAboutDOMUpdate(createdElement: Element) {
    document.dispatchEvent(new CustomEvent("dom-updated", {
        detail: {
            element: createdElement,
            plugin: null,
        },
    }));
}